import React, { useState, useEffect } from 'react'; 
import { Link } from "react-router-dom"; 
import './body.css';  // Make sure to import the CSS
import Slider from 'react-slick';
import timelineData from './timelineData'; 

function Body() {

  const [currentYearIndex, setCurrentYearIndex] = useState(0);

  // Animation interval: Change year every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentYearIndex((prevIndex) => (prevIndex + 1) % timelineData.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);


  const feedbacks = [
    {
        name: "Nimal Perera",
        feedback: "Excellent sunglasses! Fantastic quality and perfect style for our tropical climate. Highly recommended eyewear.", 
        rating: "★★★★★"
    },
    {
        name: "Chathurika Silva",
        feedback: "Love the fit and comfort! Perfect for driving around sunny Colombo. Highly recommended sunglasses for daily use.", 
        rating: "★★★★☆"
    },
    {
        name: "Kalum Fernando",
        feedback: "Impressed with the quality and style of these spectacles. Improved vision and confidence. Highly recommended eyewear.", 
        rating: "★★★★★"
    },
    {
        name: "Dilhani Wijesuriya",
        feedback: "Stylish sunglasses with excellent UV protection. Worth every cent! Highly recommended for sun protection and style.", 
        rating: "★★★★☆"
    },
    {
        name: "Kasun Jayasinghe",
        feedback: "Highly recommended! Great quality sunglasses that truly keep my eyes safe and protected from the sun's glare.", 
        rating: "★★★★★"
    },
    {
        name: "Thushi Fernando",
        feedback: "Comfortable with great sun protection for a perfect beach day. Highly recommended sunglasses for outdoor.", 
        rating: "★★★★☆"
    },
    {
        name: "Buddhi Rajapaksa",
        feedback: "Incredible sunglasses with a great design! I wear them daily while commuting in Colombo. Highly recommended eyewear.", 
        rating: "★★★★★"
    },
    {
        name: "Nadeesha Perera",
        feedback: "Stylish sunglasses that have really helped reduce eye strain when driving in bright sun in Negambo.", 
        rating: "★★★★☆"
    }
];
 
    const settings = {
      dots: true,   // Show navigation dots
      infinite: true,  // Infinite loop
      speed: 500,  // Transition speed in ms
      slidesToShow: 2,  // Show one feedback at a time
      slidesToScroll: 2,  // Scroll one feedback at a time
      autoplay: true,  // Enable auto-slide
      autoplaySpeed: 2000,  // Interval time for auto-slide
    };


    

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [ 'optical banner myopia.png', 'Optical banner 2.png', 'optical banner myopia.png', 'optical banner-17.png',  'optical banner myopia.png', 'Optical banner 2.png', 'img2.png', 'optical banner myopia.png', 'banner 3 -optical.png', 'Optical banner 2.png']; // Banners images


  // Function to change the image index
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length); // Loop back to 0 after the last image
  };


  // Use effect to create a timer for automatic sliding
  useEffect(() => {
    const intervalId = setInterval(nextImage, 3000); // Change image every 3 seconds
    return () => clearInterval(intervalId); // Clean up the interval on component unmount
  }, []);


  const brands = [
    { image: "/gucii.jpg" },
    { image: "/oakley.jpg" },
    { image: "/dolce.jpg" },
    { image: "/Carrera.jpg" },
    { image: "/eurospex.jpg" },
    { image: "/Manchester.jpg" },
    { image: "/brd1.png" },
    { image: "/brd2.png" },
    { image: "/brd8.png" },
    { image: "/brd4.png" },
    { image: "/brd5.png" },
    { image: "/brd6.png" },
    { image: "/brd7.png" },
    { image: "/brd9.jpg" },
    { image: "/brd10.png" },
    { image: "/brd11.jpg" }

  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  const Carosettings = {

    infinite: true, // Infinite scroll
    speed: 500, // Transition speed
    slidesToShow: 5, // Show one image at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Enable auto play
    autoplaySpeed: 2000, // Change image every 2 seconds
    pauseOnHover: true // Pause when hover
  };



  const products = [
    {
      id: 'S13000',
      name: 'Seven Street 7A561807140',
      price: 35000.00,
      showp: 38000.00,
      image: '/newarrival/7A561807140.jpg',
    },
 
    {
      id: 'sp11000',
      name: 'Kevino ECIKEVINO',
      price: 30000.00,
      showp: 33500.00,
      image: '/newarrival/ECIKEVINO.jpg',
    },
    {
      id: 'Sp9180',
      name: 'Joop 8207344785614145',
      showp: 69000.00,
      price: 65000.00,
      image: '/newarrival/8207344785614145.jpg',
    },
    {
      id: 'S10200',
      name: 'Che CHR 512-53-015-135 C18',
      price: 15000.00,
      image: '/newarrival/CHR 512-53-015-135 C18.jpg',
    },

    { id: 'sp101', name: 'Che ECICHE ', price: 15000.00, image: '/newarrival/ECICHE.jpg' },
    { id: 'sp102', name: 'V2 VP7225417140C94', price: 15000.00, image: '/newarrival/VP7225417140C94.jpg' },
    { id: 'sp103', name: 'Gant GA32750015220145', price: 68000.00, image: '/newarrival/GA32750015220145.jpg' },
    { id: 'sp104', name: 'Dior А1545C315616145', price: 45000.00, image: '/newarrival/А1545C315616145.jpg' },
  
  ];


  const collections = [
    {
      name: "Sunglasses",
      items: [
        {
          id: 10,
          image: "/sunglass/X2844B Transp. Brown S11557B.jpg",
          name: "smarty X2844B Transp. Brown S11557B",
          price: 15000,
          size: "Medium",
        },
        {
          id: 11,
          image: "/sunglass/X1904B Silver.jpg",
          name: "smarty X1904B Silver",
          price: 15000,
          size: "Medium",
        },
        {
          id: 12,
          image: "/sunglass/T Polarized T1900 E.jpg",
          name: "smarty T Polarized T1900 E",
          price: 15000,
          size: "Medium",
        },
   
  
        {
          id: 14,
          image: "/sunglass/865811602.jpg",
          name: "Polarized 865811602",
          price: 15000,
          size: "Medium",
        },
        {
          id: 2,
          image: "/sunglass/Y2819B Satin Black S10546B.jpg",
          name: "Smarty Y2819B Satin Black S10546B",
          price: 15000,
          size: "Medium",
        },
        {
          id: 3,
          image: "/sunglass/Y2817B Demi-Gold S11574B.jpg",
          name: "smarty Y2817B Demi-Gold S11574B",
          price: 15000,
          size: "Medium",
        },
      
        {
          id: 4,
          image: "/sunglass/X2956A Man Black.jpg", 
          name: "smarty X2956A Man Black", 
          price: 15000,         
          size: "Medium",         
        },
  
        {
          id: 5,
          image: "/sunglass/X2892A Black-Silver S11568A.jpg",
          name: "smarty X2892A Black-Silver S11568A",
          price: 15000,
          size: "Medium",
        },
  
        {
          id: 6,
          image: "/sunglass/X2889B Matt Black-Silver S11565B.jpg",
          name: "smarty X2889B Matt Black-Silver S11565B",
          price: 15000,
          size: "Medium",
        },
        {
          id: 7,
          image: "/sunglass/X2881A Black S11563A.jpg", 
          name: "smarty X2881A Black S11563A",
          price: 15000,             
          size: "Medium",          
        },
        {
          id: 8,
          image: "/sunglass/X2880C Black S11562C.jpg",
          name: "smarty",
          price: 15000,
          size: "Medium",
        },


      ],
    },
    {
      name: "Spectacles",
      items: [
        { id: 1, image: "/frame/frame.jpg", name: "Aspinal of London ASPM512", price: 110000},
        { id: 2, image: "/frame/Calvin KLEIN jeans CKJ19531A0515418145.jpg", name: "Calvin KLEIN jeans CKJ19531A0515418145", price: 54000},
        { id: 3, image: "/frame/7A5678CQ140.jpg", name: "Seven Street 7A5678CQ140", price: 35000},
        { id: 4, image: "/frame/7A561807140.jpg", name: "Seven Street 7A561807140", price: 35000 },

        
        { id: 11, image: "/frame/ECIMETOO347.jpg", name: "Lambogini ECIMETOO347", price: 65000 },
        { id: 12, image: "/frame/VL4139.jpg", name: "Lozza VL4139", price: 40000},
        { id: 13, image: "/frame/VL4212.jpg", name: "Lozza VL4212", price: 40000},
        // { id: 14, image: "/Bonia BNI1423 48-23-140 C2  6500.jpg", name: "Bonia BNI1423 48-23-140 C2", price: 6500 },
   
      ],
    },
    {
      name: "Accessories",
      items: [
        {
          id: 13,
          name: "Bio true - Multi Purpose solution 300ml",
          image: "/Bio true-img1.jpg",
          price: 2300.00,
        },
        {
          id: 14,
          name: "Bio true - Multi Purpose solution 60ml",
          image: "/bio-true-img2.jpg",
          price: 1000.00,
        },
        {
          id: 15,
          name: "Renu Multi-purpose solution 355ml",
          image: "/Renu Multi-img3.jpg",
          price: 2500.00,
        },
        {
          id: 16,
          name: "renu-multi-purpose-solution 120ml",
          image: "/multi-img4.jpg",
          price: 1500.00,
        },


        {
          id: 17,
          name: "Boston Simplus - Multi Purpose solution 120ml",
          image: "/Bostonimg5.jpg",
          price: 2500.00,
        },
        // {
        //   id: 18,
        //   name: "Polarized Clip-on Night Vision",
        //   image: "/Clip-onimg8.jpg",
        //   price: 1500,
        // },
        // {
        //   id: 19,
        //   name: "Polarized - Clip-on Black ",
        //   image: "/Clip-onimg7.jpg",
        //   price: 1500,
        // },
        {
          id: 20,
          name: "Safety Goggles - Black and Yellow",
          image: "/img/Safetyimg6.jpg",
          price:  6000
         },
      ],
    },
  ];

  

  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("cart")) || []);

  const handleAddToCart = (product) => {
    const existingProduct = cart.find((item) => item.id === product.id);

    if (existingProduct) {
      const updatedCart = cart.map((item) =>
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      );
      setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    } else {
      const newCart = [...cart, { ...product, quantity: 1 }];
      setCart(newCart);
      localStorage.setItem("cart", JSON.stringify(newCart));
    }
    alert(`${product.name} has been added to the cart!`);
  };




{/*pagination for new arrival*/}
  const itemsPerPage = 4;

  const handleNext = () => {
    if (currentIndex + itemsPerPage < products.length) {
      setCurrentIndex(currentIndex + itemsPerPage);
    }
  };

  const handlePrev = () => {
    if (currentIndex - itemsPerPage >= 0) {
      setCurrentIndex(currentIndex - itemsPerPage);
    }
  };




  return (
    <div className="body-container">
      {/* Image Carousel */}
      <div className="carousel">
        <img
          src={images[currentImageIndex]}
          alt={`carousel image${currentImageIndex + 1}`}
          className="carousel-image" />


        <Link to="/Online-Booking">
          <button className="appointment-button">Online Appointment</button>
        </Link>
      </div>

      <div className="carousel-container">
      
        <Slider {...Carosettings}>
          {brands.map((brand, index) => (
            <div key={index} className="brand-slide">
              <img src={brand.image} alt={brand.name} className="brand-image" />
              <h3>{brand.name}</h3>
            </div>
          ))}
        </Slider>
      </div>

      <> 
     {/* New Arrivals */} 
      {/* <div className="product-container">
        <h1>New Arrivals</h1>
        <div className="product-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <img src={product.image} alt={product.name} className="product-image" />
              <div className="product-details">
                <h2 className="product-name">{product.name}</h2>
                <h6 className='showp'>{product.showp}</h6>
                <div className="product-price">Rs.{product.price.toLocaleString()}</div>
                <button
                  className="view-button"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div> */}


<div className="product-container">
      <h1>New Arrivals</h1>
      <div className="pagination-controls">
        <button className="pagination-arrow" onClick={handlePrev} disabled={currentIndex === 0}>&lt;</button>
        <div className="product-grid">
          {products.slice(currentIndex, currentIndex + itemsPerPage).map((product) => (
            <div key={product.id} className="product-card">
              <img src={product.image} alt={product.name} className="product-image" />
              <div className="product-details">
                <h2 className="product-name">{product.name}</h2>
                {product.showp && <h6 className='showp'>{product.showp}</h6>}
                <div className="product-price">Rs.{product.price.toLocaleString()}</div>
                                <button
                  className="view-button-new-arrival"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
        <button className="pagination-arrow" onClick={handleNext} disabled={currentIndex + itemsPerPage >= products.length}>&gt;</button>
      </div>
    </div>


     </>

          <div className="image-container">
            <img src="/mid banner optical2.png" alt="Full Width" />
          </div>

      {/* Featured Collections */}
      <div className="featured-collection-container-unique">
        <h1>Featured Collection</h1>
        {collections.map((collection) => (
          <div key={collection.name} className="collection-section-unique">
            <h2>{collection.name}</h2>
            <div className="featured-collection-product-grid">
              {collection.items.map((item) => (
                <div key={item.id} className="featured-collection-product-card">
                  <img src={item.image} alt={item.name} className="featured-collection-product-image" />
                  <div className="featured-collection-product-details">
                    <h3>{item.name}</h3>
                    <div className="featured-collection-product-price">Rs.{item.price.toLocaleString()}</div>
                    <button
                      className="featured-collection-view-button"
                      onClick={() => handleAddToCart(item)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>


      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <h2>Why Choose Us?</h2>
        <div className="cards-container">
          <div className="card">
            <h3>Best Optometrists</h3>
            <p>Our team of highly skilled optometrists are dedicated to providing the best eye care.</p>
          </div>

          <div className="card">
            <h3>Great Service</h3>
            <p>We offer friendly, professional, and personalized service to meet your eye care needs.</p>
          </div>

          <div className="card">
            <h3>Advanced Technology</h3>
            <p>We use the latest technology to provide precise and efficient eye examinations.</p>
          </div>

          <div className="card">
            <h3>Affordable Care</h3>
            <p>Quality eye care should be accessible to all. We offer competitive pricing on all services.</p>
          </div>

        </div>
      </section>

      {/* <div className="logo-container" ref={logosContainerRef}>
        {logos.map((logo, index) => (
          <img key={index} src={logo.src} alt={logo.alt} height="100" width="120" />
        ))}
      </div> */}



<div className="timeline-container">
      <h1 className='legacy-heading'>The Legacy of Optometry in Eye Care: A Visionary Journey</h1>
      <p>Today, this iconic location continues to serve as the main headquarters for the company’s operations, providing quality eye care services to the community.</p>
      <div className="timeline">
        <div className="timeline-horizontal">
          {timelineData.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-year">
                <span className={`year-text ${index === currentYearIndex ? 'shine' : ''}`}>
                  {item.year}
                </span>
              </div>
              {item.image && (
                <div className="timeline-image-container">
                  <img src={item.image} alt={item.year} className="timeline-image" />
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="timeline-line"></div> {/* The connecting line */}
      </div>
    </div>



          <div className="feedback-carousel">
            <h2>Customer Feedback</h2>
            <Slider {...settings}>
              {feedbacks.map((feedback, index) => (
                <div key={index} className="feedback-item">
                  <p className="feedback-text">"{feedback.feedback}"</p>
                  <p className="feedback-author">- {feedback.name}</p>
                  <p className="feedback-rating">{feedback.rating}</p>
                </div>
              ))}
            </Slider>
          </div>

    </div>
  
  );
}

export default Body;